import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom"
import style from "./userPackages.module.scss"
import toPersianNumber from '../../helpers/actions/toPersianNumber'
import numberWithCommas from '../../helpers/actions/numberWithCommas'
import Button from "../Button/button"
import { GetPackages } from "../../actions/APIcalls"
import Modal from "../Modal/Modal"
import moment from "moment-jalaali"
import ExpiredAccountWarning from "../expiredAccountWarning/expiredAccountWarning";
import GradientToast from "../gradientToast/Toast"
import DownGradeWarning from "../downGradeWarning/downGradeWarning";
import Skeleton from "./skeleton"

const featureNames = [
    { feature: "تعداد تنوع‌های کالایی", englishName: "varietyCount", type: "string" },
    { feature: "بازه قیمت‌گذاری", englishName: "pricingRange", type: "string" },
    { feature: "تعداد کاربران", englishName: "userCount", type: "string" },
    { feature: "تعداد کانال‌ها", englishName: "channelCount", type: "string" },
    { feature: "تعداد رویداد در دقیقه", englishName: "eventsPerMin", type: "string" },
    { feature: "باکس فروش", englishName: "sellingBox", type: "icon" },
    { feature: "آنالیز سودآوری", englishName: "profitAnalysis", type: "icon" },
    // { feature: "گزارش فروش کالا", englishName: "sellingReport", type: "string" },
    { feature: "پشتیبانی", englishName: "support", type: "support" }
]
const UserPackages = (props) => {
    const [hasSkeleton, setHasSkeleton] = useState(false)
    const [packs, setPacks] = useState([])
    const [userPack, setUserPack] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [selectedPackage, setSelectedPackage] = useState("")
    useEffect(async () => {
        setHasSkeleton(true)
        let res = await GetPackages();
        // console.log(res, res);
        if (typeof res !== "undefined" && typeof res.data.packaging !== "undefined") {
            let index = res.data.packaging.findIndex(item => item.name === "trialPackage")
            let list = res.data.packaging
            index > -1 && list.splice(index, 1)
            setUserPack({ ...res.data.packages })
            setPacks([...list])
        }
        setHasSkeleton(false)
    }, [])

    //Renderers******************************************************
    const dataRenderer = (item, type, index2, packageName, iconValue) => {
        if (type === "icon") {
            if (iconValue === true) {
                return <div className={packageName === userPack.name ? style.goldContainer : style.container}
                    key={"child" + index2}>
                    <div className={style.greenIcon}>{toPersianNumber('f')}</div>
                </div>
            } else {
                return <div className={packageName === userPack.name ? style.goldContainer : style.container}
                    key={"child" + index2}>
                    <div className={style.redIcon}>{toPersianNumber('e')}</div>
                </div>
            }
        } else if (type === "string") {
            return <div className={packageName === userPack.name ? style.goldContainer : style.container}
                key={"child" + index2}>
                <div className={style.stringItem}>{toPersianNumber(item)}</div>
            </div>
        } else {
            return <div className={packageName === userPack.name ? style.goldContainer : style.container}
                key={"child" + index2}>
                <div className={style.support}>{toPersianNumber(item)}</div>
            </div>

        }
    }
    const modalContentRenderer = () => {
        let pack = packs.find(item => item.name === selectedPackage)
        let current = getCurrent(userPack.name)
        // console.log(pack);
        if (typeof pack !== "undefined") {
            return <div className={style.modalWrapper}>
                <div className={style.row}>
                    <div className={style.blockSizeOne}>وضعیت فعلی شما</div>
                    <div className={style.blockSizeTwo}>{pack.persianName}</div>
                    <div className={style.blockSizeThree}></div>
                </div>
                {modalRowRenderer(pack, "varietyCount", "تعداد تنوع کالاها", "تنوع ")}
                {modalRowRenderer(pack, "userCount", "تعداد کاربران", "کاربر  ")}
                {modalRowRenderer(pack, "channelCount", "تعداد کانال‌ها", "کانال  ")}
                <div className={style.warning}>
                    {
                        checkDownGrade(pack, "varietyCount") && checkDownGrade(pack, "userCount", "تعداد کاربران") && checkDownGrade(pack, "channelCount") ?
                            "خرید بسته مورد نظر، بدون مشکل قابل انجام است."
                            : (new Date(userPack.endTime) >= new Date() ?
                                " درصورتی که هنگام اتمام "
                                + current.persianName +
                                " و فعال‌سازی "
                                + pack.persianName +
                                "(تاریخ " + toPersianNumber(moment(new Date()).format('jYYYY/jMM/jDD')) + " )" +
                                "، تعداد موارد بالا بیشتر از حد مجاز باشد، ربات به صورت موقت غیرفعال می‌شود."
                                :
                                "پس از خرید این بسته، ربات به‌صورت موقت غیرفعال می‌شود. با رفع موارد خطای بالا، ربات مجدد فعال می‌شود. "
                            )
                    }
                </div>
                <div className={style.modalButtonContainer}>
                    {
                        checkDownGrade(pack, "varietyCount") && checkDownGrade(pack, "userCount") && checkDownGrade(pack, "channelCount") ?
                            ButtonPackRenderer("resume", "cancel", "تایید و ادامه", "انصراف و مشاهده بسته‌ها", () => {
                                props.history.push({
                                    pathname: "/packageconfirm/" + pack.name,
                                    state: {
                                        currentPackage: {
                                            ...userPack,
                                            // currentPackagePrice: getCurrent(userPack.name).price,
                                            persianName: current.persianName
                                        }, selectedPackage: pack
                                    }
                                })
                            }, () => setShowModal(false))

                            : (new Date(userPack.endTime) >= new Date() ?
                                ButtonPackRenderer("resume", "cancel", "تایید و ادامه", "انصراف و مشاهده بسته‌ها", () => {
                                    props.history.push({
                                        pathname: "/packageconfirm/" + pack.name,
                                        state: {
                                            currentPackage: {
                                                ...userPack,
                                                // currentPackagePrice: getCurrent(userPack.name).price,
                                                persianName: current.persianName
                                            }, selectedPackage: pack
                                        }
                                    })
                                }, () => setShowModal(false)) :
                                ButtonPackRenderer("resume", "cancel", "انصراف و کاهش موارد خطا", "تایید و ادامه", () => setShowModal(false), () => {
                                    props.history.push({
                                        pathname: "/packageconfirm/" + pack.name,
                                        state: {
                                            currentPackage: {
                                                ...userPack,
                                                // currentPackagePrice: getCurrent(userPack.name).price,
                                                persianName: current.persianName
                                            }, selectedPackage: pack
                                        }
                                    })
                                })

                            )
                    }
                </div>

            </div>
        }
    }
    const modalRowRenderer = (pack, property, rowTitle, unit) => {
        let index = pack.data.findIndex(item => item.tag === property)
        if (index >= 0) {
            return <div className={userPack[property] > pack.data[index].value ? style.rowRed : style.rowGreen}>
                <div className={style.blockSizeOne}>
                    <p className={userPack[property] > pack.data[index].value ? style.redText : style.greenText}>{toPersianNumber(userPack[property]) + " " + unit}</p>
                </div>
                <div className={style.blockSizeTwo}>{toPersianNumber(pack.data[index].value) + " " + unit}</div>
                <div className={style.blockSizeThree}>{rowTitle}</div>
            </div>
        }
    }
    const ButtonPackRenderer = (maintag, canceltag, mainlabel, cancelLabel, mainaction, cancelAction) => {
        return (
            <div className={style.buttonPack}>
                <div className={style.buttonWrapper}>
                    < Button
                        disabled={false}
                        tag={canceltag}
                        type="outline"
                        label={cancelLabel}
                        onclick={() => cancelAction()} />
                </div>
                <div className={style.buttonWrapper}>
                    < Button
                        disabled={false}
                        tag={maintag}
                        type="solid"
                        label={mainlabel}
                        onclick={() => mainaction()} />
                </div>
            </div>
        )
    }
    //handlers**********************************************************
    const selectPackage = (tag) => {
        let selected = packs.find(item => item.name === tag)
        let current = getCurrent(userPack.name)
        // console.log(current,selected);
        // console.log(userPack);
        if (userPack.name === "trialPackage") {
            props.history.push({
                pathname: "/packageconfirm/" + selected.name,
                state: {
                    currentPackage: { ...userPack, persianName: " آزمایشی" },
                    selectedPackage: selected
                }
            })

        } else {
            console.log(selected, current);
            if (selected.basePrice < current.basePrice) {
                setShowModal(true)
                setSelectedPackage(tag)

            } else {
                props.history.push({
                    pathname: "/packageconfirm/" + selected.name,
                    state: {
                        currentPackage: {
                            ...userPack,
                            // currentPackagePrice: current.basePrice,
                            persianName: current.persianName
                        }, selectedPackage: selected
                    }
                })
            }
        }
    }
    //functions*********************************************************
    const checkDownGrade = (pack, property) => {
        let index = pack.data.findIndex(item => item.tag === property)
        if (index >= 0 && userPack[property] > pack.data[index].value) {
            return false
        } else return true
    }
    const getCurrent = (tag) => {
        console.log(packs, tag);
        let current = packs.find(item => item.name === tag)
        return current
    }
    const findButtonLabel = (pack) => {
        if (pack.name === userPack.name) {
            return "تمدید"
        } else {
            let obj = packs.find(item => item.name === userPack.name)
            if (obj && pack.basePrice > obj.basePrice) {
                return "ارتقا"
            } else {
                return "انتخاب"
            }
        }
    }
    const Finder = (feature) => {
        let obj
        let array = []
        packs.forEach(Element => {
            obj = Element.data.find((item) => item.tag === feature.englishName)
            if (typeof obj !== "undefined") {
                // console.log(Element.tag);
                obj.packageName = Element.name;
                array.push(obj)
            }
        })
        return array.map((item, index) => {
            let iconValue = false
            if (item.value === "دارد") iconValue = true
            return dataRenderer(item.value, feature.type, index, item.packageName, iconValue)
        })
    }
    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                {/* {
                    Object.keys(props.user.downGradeWarning).length !== 0 &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <DownGradeWarning data={{ ...props.user.downGradeWarning }} />
                            </>
                        </GradientToast>
                    </div>
                } */}
                <Modal
                    tag='downGrade'
                    title='خرید و تمدید بسته'
                    value={showModal}
                    parentClose={() => {
                        setShowModal(false)
                    }}
                >
                    {modalContentRenderer()}
                </Modal>
                <h1>خرید و تمدید بسته</h1>
                {/* {
                props.user.expiredAccount &&
                <ExpiredAccountWarning/>
            }
            {
                Object.keys(props.user.downGradeWarning).length !== 0 &&
                <DownGradeWarning data={{...props.user.downGradeWarning}}/>
            } */}
                <div className={style.tabel}>
                    <div className={style.row}>
                        <div className={style.headerIdentifier}>
                            <div className={style.topTitle}>بسته‌ها</div>
                            {/* <div className={style.line}></div> */}
                            <div className={style.bottomTitle}>ویژگی‌ها</div>
                        </div>
                        {packs.map((item, index) => {
                            return <div className={item.name === userPack.name ? style.headerItemGold : style.headerItem}
                                key={index}>
                                <div className={style.smallTitle}>ماهانه</div>
                                <div className={style.bigTitle}>{item.persianName}</div>
                            </div>
                        })}
                    </div>

                    {featureNames.map((item, index) => {
                        return <div className={index % 2 === 0 ? style.row : style.coloredRow}>
                            <div className={style.feature}>{item.feature}</div>
                            {Finder(item)}
                        </div>
                    })

                    }
                    <div className={style.priceRow}>
                        <div className={style.rightBox}></div>
                        {packs.map((item, index) => {
                            return <div key={index} className={style.priceBoxWrapper}>
                                {item.discountAmount != 0 && <p><span
                                    // className={style.percent}>{item.discountAmount < 100 ? '%' + toPersianNumber(item.discountAmount):''}</span><span

                                    className={style.percent}>{'%' + toPersianNumber(item.discountAmount)}</span><span
                                        className={style.realPrices}>{toPersianNumber(numberWithCommas(item.basePrice))}</span>
                                </p>}
                                <div className={style.price}>{
                                    item !== "توافقی" && item !== "رایگان" && item != " " ?
                                        toPersianNumber(numberWithCommas(item.finalPrice)) + " تومان " : item
                                }
                                </div>
                            </div>
                            // <div className={style.price} key={index}>{
                            // item !== "توافقی" && item !== "رایگان" && item != " " ?
                            //     toPersianNumber(numberWithCommas(item.price)) + " تومان " : item
                            // }
                            // </div>
                        })}
                    </div>
                    <div className={style.priceRow}>
                        <div className={style.rightBox}></div>
                        {packs.map((item, index) => {
                            return <div
                                className={item.name === userPack.name ? style.buttonWrapperGold : style.buttonWrapper}
                                key={index}> {item !== " " &&
                                    <Button label={findButtonLabel(item)} type="solid" tag={item.name} onclick={selectPackage} />
                                }
                            </div>

                        })}
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(UserPackages);